import React from "react";
import { Table } from "../../layout";
import { useTranslation } from "react-i18next";

const MemberProfAtt = () => {
  const { t } = useTranslation();

  return (
    <>
      <Table
        ActionComp={() => <></>}
        HeaderComp={() => <></>}
        tblHead={[
          { id: "thumbId", label: t("ThumbId") },
          { id: "date", label: t("Date") },
          { id: "inTime", label: t("InTime") },
          { id: "outTime", label: t("OutTime") },
        ]}
        tblData={[
          {
            thumbId: "23456",
            date: "20/02/2023",
            inTime: "10:30:22 am",
            outTime: "11:30:12 am",
          },
          {
            thumbId: "23456",
            date: "20/02/2023",
            inTime: "10:30:22 am",
            outTime: "11:30:12 am",
          },
          {
            thumbId: "23456",
            date: "20/02/2023",
            inTime: "10:30:22 am",
            outTime: "11:30:12 am",
          },
          {
            thumbId: "23456",
            date: "20/02/2023",
            inTime: "10:30:22 am",
            outTime: "11:30:12 am",
          },
          {
            thumbId: "23456",
            date: "20/02/2023",
            inTime: "10:30:22 am",
            outTime: "11:30:12 am",
          },
          {
            thumbId: "23456",
            date: "20/02/2023",
            inTime: "10:30:22 am",
            outTime: "11:30:12 am",
          },
          {
            thumbId: "23456",
            date: "20/02/2023",
            inTime: "10:30:22 am",
            outTime: "11:30:12 am",
          },
        ]}
      />
    </>
  );
};

export default MemberProfAtt;
